import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../hooks/use-services.hook";
import {PrimaryButton} from "../../../../basic-components/buttons/primary-button";

export const SaveBookingButtonComponent: React.FC = observer(() => {
    const services = useServices();

    const onPayButtonClick = async () => {
        await services.booking.steps.nextStep();
    }

    const getButtonText = () => {
        if(services.booking.current.paymentHandler.holdBooking) {
            return services.language.translate('Hold booking');
        } else if(services.booking.current.paymentHandler.totalAuxiliaryPaymentsAmount > 0) {
            return services.language.translate('Pay booking');
        } else {
            return services.language.translate('Save Booking');
        }
    }

    return  (
        <PrimaryButton onClick={onPayButtonClick} fullWidth={true}>
            {getButtonText()}
        </PrimaryButton>
    );
})
